
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonLayoutComponent } from './common-layout/common-layout.component';
import { HeaderComponent } from './header/header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { FooterComponent } from './footer/footer.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        NzIconModule,
        NzLayoutModule,
        ReactiveFormsModule,
        ColorPickerModule
    ],
    declarations: [
        CommonLayoutComponent,
        HeaderComponent, FooterComponent,
        SideNavComponent, BreadcrumbComponent
    ],
    providers: [
    ],
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
    ],
})

export class LayoutsModule { }
